import { ScreenNamesInterface } from './types';

export enum ScreenNameEnums {
  HOME,
  NOT_FOUND,
  LOGIN,
  RESET_PASSWORD,
  FORGOT_PASSWORD,
  VERIFY_USER,
  SIGNUP,
  CAMPAIGNS,
  YEARLY_CAMPAIGNS,
  DAILY_CAMPAIGNS,
  COUPONS,
  RECEIVABLES,
  SEGMENT,
  SKU,
  EXPERIMENTS,
  REPORTS,
  PO,
  PO_SUMMARY,
  BULK_PO_CREATION,
  ASN,
  USER_MANAGEMENT,
  PRICING_SUMMARY,
  UPLOAD_PRICING,
  PO_MANAGEMENT,
  APPROVALS,
  BULK_JOBS,
  BULK_REPORTS,

  //Pricing Screens
  PRICING,
  LIVE_PRICING,
  SUGGESTED_PRICING,
  BUNDLE_SUGGESTED_PRICING,
  BUNDLE_LIVE_PRICING,
  BUNDLE_DETAILS,
  CBP_SUGGESTION_LISTING,
  REJECTED_BATCHES,

  PO_APPROVAL,
  HISTORICAL_PRICING,
  RETURN_PO_ACKNOWLEDGEMENT,
  CAMPAIGN_SUGGESTIONS,
}

export const ScreenNames: ScreenNamesInterface = {
  HOME: 'Dashboard',
  NOT_FOUND: 'Not Found',
  LOGIN: 'Login',
  VERIFY_USER: 'Verify User',
  RESET_PASSWORD: 'Reset Password',
  FORGOT_PASSWORD: 'Forgot Password',
  SIGNUP: 'SignUp',

  CAMPAIGNS: 'Campaigns',
  YEARLY_CAMPAIGNS: 'Yearly',
  DAILY_CAMPAIGNS: 'Daily',
  COUPONS: 'Coupons & Bank Offers',
  RECEIVABLES: 'Receivables',
  SEGMENT: 'Segments',
  SKU: 'SKUs',
  EXPERIMENTS: 'Experiments',
  REPORTS: 'Reports',
  PO: 'PO Management',
  PO_SUMMARY: 'PO Summary',
  BULK_PO_CREATION: 'Bulk PO Creation',
  ASN: 'ASN',
  USER_MANAGEMENT: 'User Management',
  PRICING_SUMMARY: 'Pricing Summary',
  UPLOAD_PRICING: 'Upload Pricing',
  PO_MANAGEMENT: 'PO Management',
  APPROVALS: 'Approvals',
  BULK_JOBS: 'Bulk Jobs',
  BULK_REPORTS: 'Bulk Reports',

  //Pricing Screens
  PRICING: 'Pricing',
  LIVE_PRICING: 'SKU Live Pricing',
  SUGGESTED_PRICING: 'SKU Insights',
  BUNDLE_SUGGESTED_PRICING: 'Bundle Insights',
  BUNDLE_LIVE_PRICING: 'Bundle Live Pricing',
  BUNDLE_DETAILS: 'Bundle Details',
  CBP_SUGGESTION_LISTING: 'CBP Suggestions',
  REJECTED_BATCHES: 'Rejected Batches',

  PO_APPROVAL: 'PO Approval',
  HISTORICAL_PRICING: 'Historical Pricing',
  RETURN_PO_ACKNOWLEDGEMENT: 'Return PO Acknowledgement',
  CAMPAIGN_SUGGESTIONS: 'Campaign Suggestions',
};
